<div [ngClass]="getClassNames('switchRow')">

  @if (allowCollapse) {
    <a (click)="toggleCollapse()" [ngClass]="getClassNames('arrowIconButton', data.collapsed ? 'collapsed' : null)">
      @if (getArrowIconTemplate(); as template) {
        <ng-container *ngTemplateOutlet="template; context: getArrowIconContext()"></ng-container>
      } @else {
        <i [ngClass]="getClassNames('arrowIcon')"></i>
      }
    </a>
  }

  @if (getButtonGroupTemplate(); as template) {
    <div [ngClass]="getClassNames('buttonGroup', 'rightAlign')">
      <ng-container *ngTemplateOutlet="template; context: getButtonGroupContext()"></ng-container>
    </div>
  } @else {
    <div [ngClass]="getClassNames('buttonGroup', 'rightAlign')">
      <button type="button" (click)="addRule()" [ngClass]="getClassNames('button')" [disabled]=disabled>
        <i [ngClass]="getClassNames('addIcon')"></i> {{translate('galis_js_QueryBuilder_AddRuleLabel')}}
      </button>
      @if (allowRuleset) {
        <button type="button" (click)="addRuleSet()" [ngClass]="getClassNames('button')" [disabled]=disabled>
          <i [ngClass]="getClassNames('addIcon')"></i> {{translate('galis_js_QueryBuilder_AddGroupLabel')}}
        </button>
      }
      @if (!!parentValue && allowRuleset) {
        <!--<button type="button" (click)="removeRuleSet()" [ngClass]="getClassNames('button', 'removeButton')" [disabled]=disabled>
        <i [ngClass]="getClassNames('removeIcon')"></i>
      </button>-->
      <div (click)="removeRuleSet()" class="remove-ruleset-icon"></div>
    }
  </div>
}

@if (getSwitchGroupTemplate(); as template) {
  <ng-container *ngTemplateOutlet="template; context: getSwitchGroupContext()"></ng-container>
} @else {
  @if (data) {
    <div [ngClass]="getClassNames('switchGroup', 'transition')">
      <div [ngClass]="getClassNames('switchControl')">
        <input type="radio" [ngClass]="getClassNames('switchRadio')" [(ngModel)]="data.condition" [disabled]=disabled
          value="and" #andOption />
          <label (click)="changeCondition(andOption.value)" [ngClass]="getClassNames('switchLabelAnd')">{{translate('galis_js_QueryBuilder_ANDLabel')}}</label>
        </div>
        <div [ngClass]="getClassNames('switchControl')">
          <input type="radio" [ngClass]="getClassNames('switchRadio')" [(ngModel)]="data.condition" [disabled]=disabled
            value="or" #orOption />
            <label (click)="changeCondition(orOption.value)" [ngClass]="getClassNames('switchLabelOr')">{{translate('galis_js_QueryBuilder_ORLabel')}}</label>
          </div>
        </div>
      }
    }



  </div>

  <div #treeContainer (transitionend)="transitionEnd($event)" [ngClass]="getClassNames('treeContainer', data.collapsed ? 'collapsed' : null)">
    @if (data && data.rules) {
      <ul [ngClass]="getClassNames('tree')">
        @for (rule of data.rules; track rule; let i = $index) {
          @if ({ruleset: !!rule.rules, invalid: !config.allowEmptyRulesets && rule.rules && rule.rules.length === 0}; as local) {
            <li [ngClass]="getQueryItemClassName(local)">
              @if (!local.ruleset) {
                @if (entities?.length > 0) {
                  <div class="q-inline-block-display">
                    @if (getEntityTemplate(); as template) {
                      <ng-container *ngTemplateOutlet="template; context: getEntityContext(rule)"></ng-container>
                    } @else {
                      <div [ngClass]="getClassNames('entityControlSize')">
                        <select [ngClass]="getClassNames('entityControl')" [(ngModel)]="rule.entity" (ngModelChange)="changeEntity($event, rule,i,data)"
                          [disabled]="disabled">
                          @for (entity of entities; track entity) {
                            <option [ngValue]="entity.value">
                              {{entity.name}}
                            </option>
                          }
                        </select>
                      </div>
                    }
                  </div>
                }
                @if (getFieldTemplate(); as template) {
                  <ng-container *ngTemplateOutlet="template; context: getFieldContext(rule)"></ng-container>
                } @else {
                  <div [ngClass]="getClassNames('fieldControlSize')">
                    <!--<select [ngClass]="getClassNames('fieldControl')" [(ngModel)]="rule.field" (ngModelChange)="changeField($event, rule)"
                    [disabled]="disabled">
                    <option *ngFor="let field of getFields(rule.entity)" [ngValue]="field.value">
                      {{field.name}}
                    </option>
                  </select>-->
                  <mat-form-field class="example-full-width" appearance="fill">
                    <input type="text"
                      placeholder="iskalno polje"
                      matInput
                      [matTooltip]="getTooltipSearchField(rule.field)"
                      [(ngModel)]="rule.field" (ngModelChange)="changeField($event, rule)"
                      [matAutocomplete]="auto">
                      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                        @for (field of getFieldsForAutoComplete(rule.entity, rule.field); track field) {
                          <mat-option [matTooltipPosition]="'right'" [matTooltip]="field.name" [value]="field.value">
                            {{field.name}}
                          </mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>
                }
                <!-- this is section where availible search fields are generated -->
                <!-- section for operators -->
                @if (getOperatorTemplate(); as template) {
                  <ng-container *ngTemplateOutlet="template; context: getOperatorContext(rule)"></ng-container>
                } @else {
                  <div [ngClass]="getClassNames('operatorControlSize','operatorMinWidth')">
                    <mat-select [ngClass]="getClassNames('operatorControl','operatorMinWidth')"
                      [(ngModel)]="rule.operator" (ngModelChange)="changeOperator(rule)"
                      [disabled]="disabled || !rule.field"
                      panelClass="qb-operator-panel"
                      disableOptionCentering>
                      @for (operator of getOperators(rule.field); track operator) {
                        <mat-option [value]="operator">
                          {{operator.Name}}
                        </mat-option>
                      }
                    </mat-select>
                  </div>
                }
                @if (findTemplateForRule(rule); as template) {
                  <ng-container *ngTemplateOutlet="template; context: getInputContext(rule)"></ng-container>
                } @else {
                  <div [ngClass]="getClassNames('inputControlSize')">
                    @switch (getInputType(rule.field, rule.operator)) {
                      @case ('string') {
                        <input [ngClass]="getClassNames('inputControl', 'inputTextField')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                          [disabled]="disabled" type="text">
                      }
                      <!--<input [ngClass]="getClassNames('inputControl', 'inputNumber')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                      [disabled]="disabled" *ngSwitchCase="'number'" type="number">-->
                      <!--<input [ngClass]="getClassNames('inputControl', 'inputDateTime')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                      [disabled]="disabled" *ngSwitchCase="'date'" type="date">-->
                      @case ('time') {
                        <input [ngClass]="getClassNames('inputControl', 'inputDateTime')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                          [disabled]="disabled" type="time">
                      }
                      @case ('number') {
                        @if (rule && rule.operator && rule.operator.Value !== 'curr_user') {
                          <input [ngClass]="getClassNames('inputControl', 'inputNumber')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()" [disabled]="disabled" type="number">
                        }
                      }
                      @case ('date') {
                        @if (rule && rule.operator && rule.operator.Value !== 'empty') {
                          <input [ngClass]="getClassNames('inputControl', 'inputDateTime')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()" [disabled]="disabled" type="date">
                        }
                      }
                      <!--<select [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                      [disabled]="disabled" *ngSwitchCase="'category'">
                      <option *ngFor="let opt of getOptions(rule.field)" [ngValue]="opt.value">
                        {{opt.name}}
                      </option>
                    </select>-->
                    @case ('category') {
                      <sem-drop-down-select class="sem-drop-down-querybuilder"
                        [filterField]="'Title'" [titleField]="'Title'"
                        [galregistryname]="getGalModelNameFromRule(rule)" [(ngModel)]="rule.value"
                        [subBindingPropertyName]="''" [preLoad]="true"
                        (ngModelChange)="changeInput()"
                        [isReadOnly]="false" name="{{rule.field}}" [type]="2"
                        [multiFieldRootPropertyBinding]="''" [waitForFilteredValue]="false" [filteredValueBinding]="''">
                      </sem-drop-down-select>
                    }
                    @case ('multiselect') {
                      <select [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                        [disabled]="disabled" multiple>
                        @for (opt of getOptions(rule.field); track opt) {
                          <option [ngValue]="opt.value">
                            {{opt.name}}
                          </option>
                        }
                      </select>
                    }
                    @case ('boolean') {
                      <input [ngClass]="getClassNames('inputControl', 'inputCheckbox')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                        [disabled]="disabled" type="checkbox">
                    }
                    @case ('multiplesearchfield') {
                      @if (config.fields[rule.field] && config.fields[rule.field].settings) {
                        <div class="dynamic-multiple-field-containe-first-row">
                          @for (column of config.fields[rule.field].settings.Columns; track column; let colIndex = $index) {
                            <div class="dynamic-multiple-field-container">
                              @for (row of column.Rows; track row; let rowIndex = $index) {
                                <div>
                                  @if (colIndex == 1) {
                                    <span class="multiple-field-separator">-</span>
                                  }
                                  @if (colIndex == 2) {
                                    <span class="multiple-field-separator">/</span>
                                  }
                                  <sem-text-box class="multiple-field-dynamic-text-box" name="name" [(ngModel)]="rule[row.PropertyBinding].SearchValueFrom"></sem-text-box>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    }
                  }
                </div>
              }
              @if (getRemoveButtonTemplate(); as template) {
                <div [ngClass]="getClassNames('buttonGroup', 'rightAlign')">
                  <ng-container *ngTemplateOutlet="template; context: getRemoveButtonContext(rule)"></ng-container>
                </div>
              } @else {
                <div [ngClass]="getClassNames('removeButtonSize', 'rightAlign', 'removeRuleIconContainer')">
                  <div (click)="removeRule(rule, data)" class="remove-rule-icon"></div>
                  <!--<button type="button" [ngClass]="getClassNames('button', 'removeButton')" (click)="removeRule(rule, data)" [disabled]=disabled>
                  <i [ngClass]="getClassNames('removeIcon')"></i>
                </button>-->
              </div>
            }
          }
          @if (local.ruleset) {
            <query-builder class="rule-group-querybuilder" [data]="rule" [disabled]="disabled" [parentTouchedCallback]="parentTouchedCallback || onTouchedCallback"
              [parentChangeCallback]="parentChangeCallback || onChangeCallback" [parentInputTemplates]="parentInputTemplates || inputTemplates"
              [parentOperatorTemplate]="parentOperatorTemplate || operatorTemplate" [parentFieldTemplate]="parentFieldTemplate || fieldTemplate"
              [parentEntityTemplate]="parentEntityTemplate || entityTemplate" [parentSwitchGroupTemplate]="parentSwitchGroupTemplate || switchGroupTemplate"
              [parentButtonGroupTemplate]="parentButtonGroupTemplate || buttonGroupTemplate" [parentRemoveButtonTemplate]="parentRemoveButtonTemplate || removeButtonTemplate"
              [parentEmptyWarningTemplate]="parentEmptyWarningTemplate || emptyWarningTemplate" [parentArrowIconTemplate]="parentArrowIconTemplate || arrowIconTemplate"
              [parentValue]="data" [classNames]="classNames" [config]="config" [allowRuleset]="allowRuleset"
              [allowCollapse]="allowCollapse" [emptyMessage]="emptyMessage" [operatorMap]="operatorMap">
            </query-builder>
          }
          @if (getEmptyWarningTemplate(); as template) {
            @if (local.invalid) {
              <ng-container *ngTemplateOutlet="template; context: getEmptyWarningContext()"></ng-container>
            }
          } @else {
            @if (local.invalid) {
              <p [ngClass]="getClassNames('emptyWarning')">
                {{translate(emptyMessage)}}
              </p>
            }
          }
        </li>
      }
    }
  </ul>
}
</div>
